module.exports = __webpack_public_path__ + "img/jasmine.e66db3d9.svg";